export const INIT_SOCKET = "INIT_SOCKET";
export const DISCONNECT = "DISCONNECT";
export const CHAT_ECHO = "CHAT_ECHO";
export const CHAT_UPDATE = "CHAT_UPDATE";
export const CHAT_RESUME = "CHAT_RESUME";
export const NOTE_ECHO = "NOTE_ECHO";
export const NOTE_UPDATE = "NOTE_UPDATE";
export const NOTE_RESUME = "NOTE_RESUME";
export const FUNCTIONALITIES_ECHO = "FUNCTIONALITIES_ECHO";
export const SLIDE_ECHO = "SLIDE_ECHO";
export const PARTICIPANTS_RESUME = "PARTICIPANTS_RESUME";
export const SYNC_UNDERSTANDING_ECHO = "SYNC_UNDERSTANDING_ECHO";
export const ASYNC_UNDERSTANDING_ECHO = "ASYNC_UNDERSTANDING_ECHO";
export const SYNC_UNDERSTANDING_RESUME = "SYNC_UNDERSTANDING_RESUME";
export const ASYNC_UNDERSTANDING_RESUME = "ASYNC_UNDERSTANDING_RESUME";
export const GRAPH_UPDATE = "GRAPH_UPDATE";
export const SET_GRAPH = "SET_GRAPH";
export const GRAPH_UPDATE_INTERVAL = "GRAPH_UPDATE_INTERVAL";
export const STOP_GRAPH_UPDATE = "STOP_GRAPH_UPDATE";
export const QUESTIONS_RESUME = "QUESTIONS_RESUME";
export const BOOKMARKS_RESUME = "BOOKMARKS_RESUME";
export const BOOKMARK_ECHO = "BOOKMARK_ECHO";

const SocketReducer = (state, action) => {
  switch (action.type) {
    case INIT_SOCKET:
      return {
        ...state,
        socket: action.payload.socket,
        connectedRoom: action.payload.room,
      };
    case DISCONNECT:
      state.socket.removeAllListeners();
      return {
        ...state,
        socket: state.socket.disconnect(),
        connectedRoom: null,
      };
    case CHAT_ECHO:
    case CHAT_UPDATE:
      const uuid = action.payload.uuid;

      return {
        ...state,
        chatMessages: { ...state.chatMessages, [uuid]: action.payload },
      };
    case CHAT_RESUME:
      return {
        ...state,
        chatMessages: Object.fromEntries(action.payload.map((item) => [item.uuid, item])),
      };
    case QUESTIONS_RESUME:
      console.log(action.payload);
      return {
        ...state,
        questions: action.payload,
      };
    case NOTE_ECHO:
      return {
        ...state,
        notes: [...state.notes, action.payload],
      };
    case NOTE_UPDATE:
      return {
        ...state,
        notes: state.notes.map((note) => (note.uuid === action.payload.uuid ? action.payload : note)),
      };
    case NOTE_RESUME:
      return {
        ...state,
        notes: action.payload,
      };
    case FUNCTIONALITIES_ECHO:
      return {
        ...state,
        functionalities: action.payload,
      };
    case SLIDE_ECHO:
      return {
        ...state,
        slideNumber: action.payload,
      };
    case PARTICIPANTS_RESUME:
      return {
        ...state,
        participants: action.payload,
      };
    case SYNC_UNDERSTANDING_ECHO:
      return {
        ...state,
        globalUnderstanding: action.payload,
        syncUnderstandings: [
          ...state.syncUnderstandings,
          { videoTs: action.payload.videoTs, percentage: getUnderstandingPercentage(action.payload) },
        ],
      };
    case ASYNC_UNDERSTANDING_ECHO:
      return {
        ...state,
        asyncUnderstandings: [...state.asyncUnderstandings, action.payload],
      };
    case SYNC_UNDERSTANDING_RESUME:
      return {
        ...state,
        syncUnderstandings: action.payload.reactions,
        graphVideoTime: action.payload.videoTime,
        globalUnderstanding: { counters: action.payload.counters, videoTs: action.payload.videoTime },
      };
    case ASYNC_UNDERSTANDING_RESUME:
      return {
        ...state,
        asyncUnderstandings: action.payload,
      };
    case SET_GRAPH:
      return {
        ...state,
        graphCache: action.payload,
      };
    case GRAPH_UPDATE:
      let percentage = getUnderstandingPercentage(state.globalUnderstanding);
      if (percentage) percentage *= 100;
      const newGraphCache = [...state.graphCache.slice(1), percentage];

      return {
        ...state,
        graphCache: newGraphCache,
        graphVideoTime: state.graphVideoTime + 1,
      };
    case STOP_GRAPH_UPDATE:
      clearInterval(state.graphInterval);
      return { ...state, graphInterval: null };
    case GRAPH_UPDATE_INTERVAL:
      return {
        ...state,
        graphInterval: action.payload,
      };
    case BOOKMARK_ECHO:
      return {
        ...state,
        bookmarks: [...state.bookmarks, action.payload],
      };
    case BOOKMARKS_RESUME:
      return { ...state, bookmarks: action.payload };
    default:
      return state;
  }
};

const getUnderstandingPercentage = (globalUnderstanding) => {
  const low = parseInt(globalUnderstanding.counters.low);
  const mid = parseInt(globalUnderstanding.counters.mid);
  const high = parseInt(globalUnderstanding.counters.high);

  if (low + mid + high === 0) return undefined;

  return (mid * 0.5 + high * 1) / (low + mid + high);
};

export default SocketReducer;
